var _circle, _path, _path2, _rect, _rect2, _path3, _path4, _g, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5586,
    cy: 66.5,
    r: 33.5,
    fill: "#EAECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5371 17C65.5371 17 35.6919 17.0156 35.6452 17.0156C24.9154 17.0816 18.2715 24.1416 18.2715 34.9103V56.6608C18.2715 67.4839 24.966 74.5711 35.7891 74.5711C35.7891 74.5711 65.6304 74.5594 65.681 74.5594C76.4108 74.4933 83.0586 67.4295 83.0586 56.6608V34.9103C83.0586 24.0871 76.3603 17 65.5371 17Z",
    fill: "white",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 57C75 52.5817 71.4183 49 67 49H34",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 33,
    height: 32,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 33,
    height: 32,
    rx: 16,
    stroke: "#513DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1626 33H19.8374C19.3749 33 19 32.6251 19 32.1626C19 30.8675 19.25 29.5981 19.7233 28.4191C20.6909 26.0086 23.4026 25.0566 26 25.0566C28.5974 25.0566 31.3091 26.0086 32.2767 28.4191C32.75 29.5981 33 30.8675 33 32.1626C33 32.6251 32.6251 33 32.1626 33Z",
    fill: "#EAECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1626 13H19.8374C19.3749 13 19 13.3749 19 13.8374C19 16.5027 20.0588 19.0588 21.9434 20.9434L23.1626 22.1626C23.2836 22.2836 23.3442 22.3442 23.3875 22.4023C23.6519 22.7569 23.6519 23.2431 23.3875 23.5977C23.3442 23.6558 23.2836 23.7164 23.1626 23.8374L21.9434 25.0566C20.0588 26.9412 19 29.4973 19 32.1626C19 32.6251 19.3749 33 19.8374 33H32.1626C32.6251 33 33 32.6251 33 32.1626C33 29.4973 31.9412 26.9412 30.0566 25.0566L28.8374 23.8374C28.7164 23.7164 28.6558 23.6558 28.6125 23.5977C28.3481 23.2431 28.3481 22.7569 28.6125 22.4023C28.6558 22.3442 28.7164 22.2836 28.8374 22.1626L30.0566 20.9434C31.9412 19.0588 33 16.5027 33 13.8374C33 13.3749 32.6251 13 32.1626 13Z",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3197_23764)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 25,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.29 32C70.29 29.7909 68.4992 28 66.29 28V28",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6672 40.8069C71.1454 39.137 69.5988 38 67.8493 38H64.7308",
    stroke: "#513DD3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 25.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#513DD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3197_23764"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 25,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutIcon);
export default __webpack_public_path__ + "static/media/timeout-icon.430597bf64103932fdc0f0c465389f1d.svg";
export { ForwardRef as ReactComponent };